module.exports = __webpack_public_path__ + "img/silver4.db4bd0b1.png";